export function invalidMinScore(minScore: number | undefined, maxScore: number | undefined): boolean {
  if (minScore === undefined) return true;
  if (maxScore === undefined) return false;
  return minScore >= maxScore || minScore < 0;
}

export function invalidMaxScore(minScore: number | undefined, maxScore: number | undefined): boolean {
  if (maxScore === undefined) return true;
  if (minScore === undefined) return false;
  return maxScore <= minScore || maxScore > 100;
}
